import React from 'react';
import { FaArrowRight } from "react-icons/fa";
import { Controller } from 'react-hook-form';
import 'stylesheets/comman/inputBox.scss';

const CheckboxGroup = ({ rows, name, control, options, rules, label, subText, onSubText, defaultValue = [] }) => {
  return (
    <div className="form-group">
      {label && <label className="title">{label}</label>}
      {subText && <span onClick={onSubText} className='subLabel'>{subText} <FaArrowRight /></span>}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => {
          const handleChange = (value) => {
            const currentValues = field.value || [];
            const updatedValues = currentValues.includes(value)
              ? currentValues.filter((val) => val !== value)
              : [...currentValues, value];

            field.onChange(updatedValues);
          };

          return (
            <div className={`radioWrap ${rows ? 'rows' : ''}`}>
              {options.map((opt, idx) => (
                <label key={idx}>
                  <input
                    type="checkbox"
                    value={opt.value}
                    checked={field.value?.includes(opt.value)}
                    onChange={() => handleChange(opt.value)}
                  />
                  <span>{opt.label}</span>
                </label>
              ))}
              {fieldState.error && (
                <span className='error'>
                  {fieldState.error.message}
                </span>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default CheckboxGroup;
